module.exports = __webpack_public_path__ + "img/1.37ef21c1.png";